import { AnyAction } from 'redux';
import { GlobalActions, GlobalAction } from '@ps20-frontend/shop-integration-redux';
import { Domaenenwert, EinstiegResponse } from '@ps20/bff-models';

export interface VersicherungsnehmerDashboard {
  kundenverwaltungID: string;
  groupId: string;
  businessForm?: Domaenenwert;
}

export const versicherungsnehmerReducer = function (
  sectionState: VersicherungsnehmerDashboard = null,
  action: AnyAction,
): VersicherungsnehmerDashboard {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL:
      return loadVn(sectionState, action);
    default:
      return sectionState;
  }
};

function loadVn(
  sectionState: VersicherungsnehmerDashboard,
  action: AnyAction,
): VersicherungsnehmerDashboard {
  const { kundenverwaltungID, groupId, businessForm } = (action as GlobalAction<EinstiegResponse>)
    .payload.versicherungsnehmer;
  return { ...sectionState, kundenverwaltungID, groupId, businessForm };
}
